import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  FileDownloadControlDto,
  FileDto,
} from 'src/app/data/models/dto/file.dto';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { FileService } from 'src/app/data/services/file.service';
import { FileUtils } from 'src/app/data/utils/file.utils';

import { CustomSnackbarService } from '../custom-snackbar/custom-snackbar-service';
import { FileUploadListComponent } from '../file-upload-list/file-upload-list.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit, OnChanges {
  @Input() initialFiles: string[] | FileDto[] = [];
  @Input() disabled: boolean = false;
  newStructure = true;
  oldStructureInitialFiles: string[] = [];
  newStructureInitialFiles: FileDto[] = [];

  @Input() text: string | undefined = 'texto personalizado AQ...';
  @Input() type: string | undefined = 'attachment';
  @Input() filePathOldStructure: string = '';

  @Output() currentFilesEmitter = new EventEmitter<any[]>();
  @Output() filesToDeleteEmitter = new EventEmitter<any[]>();
  addedFiles: any[] = [];
  filesToDelete: any[] = [];

  downloadFilesControl: FileDownloadControlDto[] = [];
  files: File[] = [];
  textUploadButton: string = 'Adicionar imagem';
  attribAccpet: string = '*/*';
  imgURL: any[] = [];

  pdfIcon = '../../../../assets/icons/pdf-img.png';
  nonPdfIcon = '../../../../assets/icons/file_download.png';

  uploadInProgress = false;
  showSelectFileDialog = true;
  subscribeDialog = new Subscription();

  constructor(
    private dialog: MatDialog,
    private cookieService: CookieService,
    private fileService: FileService,
    private fileUtils: FileUtils,
    private snackbarService: CustomSnackbarService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.newStructure =
      this.initialFiles.length == 0
        ? true
        : this.initialFiles[0] instanceof Object;
    this.showSelectFileDialog = !(
      this.type === 'background' && this.initialFiles.length > 0
    );
    this.initFileArrays();
  }

  ngOnInit(): void {
    this.attribAccpet = this.type === 'background' ? 'image/*' : '*/*';
    this.textUploadButton =
      this.text !== undefined ? this.text : 'Adicionar imagem';
  }

  private initFileArrays() {
    if (this.newStructure) this.initArraysNewStructure();
    else this.initArraysOldStructure();
    this.initialFiles.forEach(() => this.imgURL.push(null));
  }

  private initArraysNewStructure() {
    this.newStructureInitialFiles = this.initialFiles as FileDto[];
    this.downloadFilesControl = this.newStructureInitialFiles.map((file) => {
      return new FileDownloadControlDto(
        file.id,
        file.bucketKey,
        file.path,
        file.name,
        false
      );
    });
  }
  private initArraysOldStructure() {
    this.oldStructureInitialFiles = this.initialFiles as string[];
    this.downloadFilesControl = this.oldStructureInitialFiles.map((file) => {
      return new FileDownloadControlDto(
        '',
        '',
        this.filePathOldStructure,
        file,
        false
      );
    });
  }

  async onFilesSelected(event: any) {
    let filesToUpload: File[] = [];
    let e = event || window.event;
    for (var i = 0; i < e.target.files.length; i++) {
      let f = e.target.files[i];
      if (!this.validateFile(f) || this.sameNameFile(f.name)) {
        return;
      }
      filesToUpload.push(f);
      if (this.type === 'background') break;
    }
    if (filesToUpload.length == 0) return;
    this.openDialog(filesToUpload);
  }

  private openDialog(filesToUpload: File[]) {
    const dialogRef = this.dialog.open(FileUploadListComponent, {
      data: {
        files: filesToUpload,
        filePathOldStructure: this.filePathOldStructure,
      },
      disableClose: true,
      panelClass: 'custom-dialog-container',
      autoFocus: false,
    });
    this.subscribeDialog = dialogRef.componentInstance.onSuccess.subscribe(
      () => {
        this.updateArrays(
          filesToUpload,
          dialogRef.componentInstance.uploadedFiles
        );
        this.showSelectFileDialog = !(
          this.type === 'background' && this.downloadFilesControl.length > 0
        );

        if (this.newStructure) {
          this.currentFilesEmitter.emit(
            this.mapFileDownloadControl(this.downloadFilesControl)
          );
        } else {
          this.currentFilesEmitter.emit(
            this.downloadFilesControl.map((f) => f.name)
          );
        }

        dialogRef.close();
      }
    );
    this.subscribeDialog = dialogRef.componentInstance.onCancel.subscribe(
      () => {
        dialogRef.close();
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.subscribeDialog.unsubscribe();
    });
  }

  private updateArrays(files: File[], uploadedFilesInfo: FileDto[]) {
    if (this.type === 'background') {
      this.imgURL = [];
      this.downloadFilesControl = [];
      this.files = [];
    }
    files.forEach((f) => {
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = (_event) => {
        this.imgURL.push(reader.result);
      };
      this.files.push(f);
    });
    uploadedFilesInfo.forEach((upFile) => {
      this.downloadFilesControl.push(
        new FileDownloadControlDto(
          upFile.id,
          upFile.bucketKey,
          upFile.path,
          upFile.name,
          true
        )
      );
    });
  }

  private mapFileDownloadControl(files: FileDownloadControlDto[]): FileDto[] {
    let retFiles: FileDto[] = [];
    files.forEach((f) => {
      retFiles.push({
        id: f.id,
        bucketKey: f.bucketKey,
        path: f.path,
        name: f.name,
      } as FileDto);
    });
    return retFiles;
  }

  private validateFile(file: any) {
    const typePdf:boolean = file.type === 'application/pdf'
    if (
      file.type &&
      ((file.type.match(/^image\//) || typePdf) &&
      this.fileUtils.validateSize(file.size, typePdf)) 
    )
      return true;
    this.snackbarService.open(
      'O formato ou tamanho do arquivo não é suportado.',
      SnackbarTypeEnum.ERROR,
      'center',
      'bottom'
    );
    return false;
  }

  private sameNameFile(fileName: string) {
    if (this.downloadFilesControl.some((el) => el.name == fileName)) {
      this.snackbarService.showNotification('Arquivo com mesmo nome.', 2000);
      return true;
    }
    return false;
  }

  fileExtension(fileName: string) {
    return this.fileUtils.fileExtension(fileName);
  }

  fileSize(fileName: string) {
    const file = this.files.find((f) => f.name == fileName);
    return file ? this.fileUtils.formatBytes(file.size) : '';
  }

  fileInfoExists(fileName: string) {
    return this.files.some((f) => f.name == fileName);
  }

  isImage(name: string) {
    return this.fileUtils.isImage(name);
  }

  async onDownloadClick(
    item: FileDownloadControlDto,
    index: number,
    event: boolean
  ): Promise<void> {
    if (item.isActive === false && event) {
      item.processing = new Subject<boolean>();
      item.processing.next(false);
      const arqFile = await this.getFile(item);
      if (arqFile) {
        this.filePreview(arqFile, index);
        saveAs(arqFile, item.name!);
        item.isActive = true;
        this.files.push(arqFile);
      }
    } else {
      item.processing?.next(!event);
    }
  }

  private getFile(fileDto: FileDownloadControlDto): Promise<File> {
    const object = new Promise<File>(async (resolve, reject) => {
      try {
        const arrayBuffer = await this.fileService
          .downloadByUrlPath(fileDto.path)
          .pipe(takeUntil(fileDto.processing!.asObservable()))
          .toPromise();

        const arqFile = this.fileUtils.FromByteArrayToFile(
          arrayBuffer,
          fileDto.name
        );
        resolve(arqFile);
      } catch (error) {
        console.log('error to downloadFile: ', error);
        reject(new File([''], ''));
      }
    });
    return object;
  }

  private filePreview(file: File, index: number) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL[index] = reader.result;
    };
  }

  async onRemoveFileClick(fileName: string, it: number) {
    if (!this.disabled) {

      this.imgURL.splice(it, 1);
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].name === fileName) {
          this.files.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.downloadFilesControl.length; i++) {
        if (this.downloadFilesControl[i].name === fileName) {
          if (this.isInitialFile(fileName))
            this.filesToDelete.push(this.downloadFilesControl[i]);
          else
            this.fileService.delete(this.downloadFilesControl[i].id).toPromise();
          this.downloadFilesControl.splice(i, 1);
          break;
        }
      }
      this.showSelectFileDialog = !(
        this.type === 'background' && this.downloadFilesControl.length > 0
      );

      if (this.newStructure) {
        this.currentFilesEmitter.emit(
          this.mapFileDownloadControl(this.downloadFilesControl)
        );
        this.filesToDeleteEmitter.emit(
          this.mapFileDownloadControl(this.filesToDelete)
        );
      } else {
        this.currentFilesEmitter.emit(
          this.downloadFilesControl.map((f) => f.name)
        );
        this.filesToDeleteEmitter.emit(this.filesToDelete.map((f) => f.name));
      }
    }
  }

  private isInitialFile(fileName: string): boolean {
    if (this.newStructure) {
      return this.newStructureInitialFiles.some((f) => f.name == fileName);
    } else {
      return this.oldStructureInitialFiles.some((f) => f == fileName);
    }
  }
}
